var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68798 4.08451L7.45654 3.84371C8.17797 3.61831 8.94724 3.98301 9.25653 4.69562L9.87009 6.11524C10.1372 6.73335 9.98938 7.46065 9.50295 7.91286L8.15011 9.17147C8.23297 9.92468 8.49153 10.666 8.92439 11.3954C9.33566 12.1012 9.88725 12.7189 10.5465 13.2119L12.1715 12.6799C12.7879 12.479 13.4586 12.7107 13.8358 13.2546L14.7165 14.5216C15.1558 15.1544 15.0772 16.0267 14.5322 16.5629L13.9479 17.1376C13.3665 17.7095 12.5358 17.9174 11.7679 17.6822C9.95438 17.1278 8.28725 15.482 6.76584 12.745C5.24228 10.0038 4.70443 7.67696 5.153 5.76733C5.34156 4.96372 5.92513 4.32322 6.68798 4.08451Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile_icon.98059f76ef603ff350861ef59a461719.svg";
export { ForwardRef as ReactComponent };